import { shallowEqual, useSelector } from 'react-redux';
import capitalize from 'lodash/capitalize';

import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { NsDescriptionList } from 'components/common/ns-description-list/NsDescriptionList';
import { selectRegisters } from 'state/meter-reads/move-in-meter-read-slice';
import {
  selectElectricityRegisters,
  selectGasRegisters
} from 'state/move-in-date/move-in-date-slice';
import { FUEL_NAMES, FUEL_TYPES } from 'config/app-config';

export const testId = 'meterReadTolleranceErrorTestId';

type MeterReadTolleranceErrorProps = {
  title?: string;
};

export const MeterReadTolleranceError = ({ title }: MeterReadTolleranceErrorProps) => {
  const registers = useSelector(selectRegisters, shallowEqual) || [];
  const electricityRegisters =
    useSelector(selectElectricityRegisters, shallowEqual) || [];
  const gasRegisters = useSelector(selectGasRegisters, shallowEqual) || [];
  const registersObj = registers.reduce((acc, { registerId, valid }) => {
    return {
      ...acc,
      [registerId]: valid
    };
  }, {});

  const getInvalidFuelRegisters = (fuelRegisters, fuelName) => {
    return fuelRegisters?.reduce((acc, register) => {
      const { id, period } = register;
      const periodLabel = period ? `(${capitalize(period)})` : '';
      const label = [capitalize(fuelName), periodLabel]
        .filter(Boolean)
        .join(' ');
      const isInvalid = !registersObj[id];

      return [
        ...acc,
        isInvalid && {
          term: label,
          description: <a href={`#${id}`}>Please check and try again</a>,
          key: id
        }
      ];
    }, []);
  };

  const invalidElectricityReads = getInvalidFuelRegisters(
    electricityRegisters,
    FUEL_NAMES[FUEL_TYPES.ELECTRIC]
  );
  const invalidGasReads = getInvalidFuelRegisters(
    gasRegisters,
    FUEL_NAMES[FUEL_TYPES.GAS]
  );
  const invalidReads = [...invalidElectricityReads, ...invalidGasReads];

  return (
    <NsAlert state="warning" heading={title} testId={testId}>
      <NsDescriptionList>{invalidReads}</NsDescriptionList>
      <p>
        Remember to only add numbers before the decimal place. If you&apos;d
        like us to estimate instead, please leave the reading field blank.
      </p>
    </NsAlert>
  );
};
